export const mockRecommendationDeeplink = {
  id: 123,
  color_hex: "#2B1232",
  image_url: "https://images.hallow.app/covers/1438_s.webp",
  title: "Lent Pray40",
  description: "Pray through Lent",
  deeplink: "hallow://collections/1438",
};
